// @ts-strict-ignore
import type { MarketoParams } from "./types";

export const allowedMarketoKeys = [
  "INT_UTM_Medium_Most_Recent__c",
  "INT_UTM_Source_Most_Recent__c",
  "INT_UTM_Campaign_Most_Recent__c",
  "INT_UTM_Content_Most_Recent__c",
  "INT_UTM_Term_Most_Recent__c",
  "INT_Conversion_Page_Most_Recent__c",
  "INT_Conversion_Date_Most_Recent__c",
  "utm_campaign",
  "utm_medium",
  "utm_source",
  "utm_content",
  "utm_term",
  "GCLID__c",
];

export const marketoParamsDefault: MarketoParams = {
  INT_UTM_Medium_Most_Recent__c: "",
  INT_UTM_Source_Most_Recent__c: "",
  INT_UTM_Campaign_Most_Recent__c: "",
  INT_UTM_Content_Most_Recent__c: "",
  INT_UTM_Term_Most_Recent__c: "",
  INT_Conversion_Page_Most_Recent__c: "",
  INT_Conversion_Date_Most_Recent__c: "",
  utm_campaign: "",
  utm_medium: "",
  utm_source: "",
  utm_content: "",
  utm_term: "",
  GCLID__c: "",
};

export const handleMarketoQueryParams = (
  queryParams: URLSearchParams = new URLSearchParams(window.location.search)
) => {
  const newParams = {} as MarketoParams;
  for (const [key, value] of queryParams.entries()) {
    if (allowedMarketoKeys.includes(key)) {
      if (typeof value === "string") {
        newParams[key] = value;
      }
    }
  }

  if (!newParams.INT_Conversion_Page_Most_Recent__c && document.referrer) {
    newParams.INT_Conversion_Page_Most_Recent__c = document.referrer;
  }

  return newParams;
};
